const { default: axiosIns } = require('@/libs/axios')

const RenderDebugger = {
  // GET - RenderDebuggerApiController
  async getAds(searchTerm = '') {
    return axiosIns.get(`admin/render/debugger?searchTerm=${encodeURIComponent(searchTerm)}`).then(response => response.data)
  },
  async generateRenderUrl(id) {
    return axiosIns.get(`admin/render/debugger/url?adId=${id}`).then(response => response.data)
  },
}
export default RenderDebugger
